module.exports = __webpack_public_path__ + "static/img/最受欢迎新能源车.bdb80d97.png";